<script>
  import { onMount, setContext } from "svelte";
  import { FormGroup, Label, Input } from "sveltestrap";

  import axios from "axios";

  import NavbarSuccess from "../NavbarSuccess.svelte";
  import HoursForm from '../containers/HoursForm.svelte';
  import HoursTable from '../containers/HoursTable.svelte';

  let user = null;
  let location = window.location.origin;
  let shownView = 'form';

  let form = {
    startDate: null,
    endDate: null,
    staffId: '',
    teamId: '',
    filter: '',
  };

  setContext('hours', {
    showForm: () => shownView = 'form',
    showList: (startDate, endDate, staffId, teamId, filter) => {
      form = {
        startDate: startDate,
        endDate: endDate,
        staffId: staffId,
        teamId: teamId,
        filter: filter,
        refreshData: true,
      };

      shownView = 'list';
    },
    getUser: () => user,
  })

  onMount(() => {
    getUser();
  });

  async function getUser() {
    const res = await fetch("/authentication/GetUserDetails");
    const json = await res.json();
    user = json.Result;
    if (json.StatusCode === 401) {
      window.location = "/login";
      document.title = "Login";
    } else {
      if (user.Type === 1) {
        document.onmousemove = function() {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            handleLogout();
          }, 60000 * 25);
        };
      }
    }
  }
</script>

<style>
</style>

<NavbarSuccess>
  <ul>
    <li style="background-color:  #304c63;">
      <a href="/reports/hours">Hours</a>
    </li>
    <li>
      <a href="/reports/pto">PTO</a>
    </li>
  </ul>
</NavbarSuccess>
{#if shownView === 'form'}
  <HoursForm/>
{:else if shownView === 'list'}
  <HoursTable {...form}/>
{/if}
